import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa'

import hausmartLogo from '../../../assets/svg/Hausmart_logo_text.svg'
import LangPicker from '../../../components/layout/LangPicker/LangPicker'
import { SHOPIFY_APP_STORE_URL, HAUSMART_SOCIAL } from '../../../constants/appLinks'
import {
  FooterInner,
  BrandColumn,
  Logo,
  ColumnTitle,
  LinkFooter,
  LinkFooterExternal,
  BottomSection,
  LegalLinks,
  LegalDot,
  SocialRow,
  SocialLink,
  CircleIcon,
  LangPickerWrap
} from '../../../components/layout/Footer/FooterStyledComponents'
import { PageFooter, FooterTop, FooterColumn, FooterEmail, LegalAddress, LinksCluster } from './FooterStyledComponents'

const CONTACT_EMAIL = 'hausmart@hausmart.com'

const Footer = () => (
  <PageFooter>
    <FooterInner>
      <FooterTop>
        <BrandColumn>
          <Logo src={hausmartLogo} alt="HausMart logo" />
          <LegalAddress>
            <FormattedMessage id="homepage.footer.legal" />
          </LegalAddress>
        </BrandColumn>

        <LinksCluster>
          <FooterColumn>
            <ColumnTitle>
              <FormattedMessage id="footer.contact" />
            </ColumnTitle>
            <FooterEmail href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</FooterEmail>
          </FooterColumn>

          <FooterColumn>
            <ColumnTitle>
              <FormattedMessage id="homepage.footer.links" />
            </ColumnTitle>
            <LinkFooterExternal href={SHOPIFY_APP_STORE_URL}>
              <FormattedMessage id="homepage.footer.shopify" />
            </LinkFooterExternal>
          </FooterColumn>
        </LinksCluster>
      </FooterTop>

      <BottomSection>
        <LangPickerWrap>
          <LangPicker />
        </LangPickerWrap>
        <LegalLinks>
          <LinkFooter to="/terms/1/Term-of-service">
            <FormattedMessage id="footer.termsOfService" />
          </LinkFooter>
          <LegalDot>·</LegalDot>
          <LinkFooter to="/terms/4/Privacy-Policy">
            <FormattedMessage id="footer.privacyPolicy" />
          </LinkFooter>
          <LegalDot>·</LegalDot>
          <LinkFooterExternal href="#">
            <FormattedMessage id="homepage.footer.security" />
          </LinkFooterExternal>
        </LegalLinks>
        <SocialRow>
          <SocialLink
            href={HAUSMART_SOCIAL.facebook}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="HausMart on Facebook"
          >
            <CircleIcon>
              <FaFacebookF />
            </CircleIcon>
          </SocialLink>
          <SocialLink
            href={HAUSMART_SOCIAL.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="HausMart on Instagram"
          >
            <CircleIcon>
              <FaInstagram />
            </CircleIcon>
          </SocialLink>
          <SocialLink
            href={HAUSMART_SOCIAL.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="HausMart on LinkedIn"
          >
            <CircleIcon>
              <FaLinkedinIn />
            </CircleIcon>
          </SocialLink>
        </SocialRow>
      </BottomSection>
    </FooterInner>
  </PageFooter>
)

Footer.displayName = 'Footer'

export default Footer
